import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Routes } from '../../Routes';
import { ParameterView } from './ParameterView';
import { Parameters } from './Parameters';
import { SuspenseLoading } from '../../components/Common/SuspenseLoading';
import { PermissionRoute } from '../../components/Common/PermissionComponent';
import { Permissions } from '../../Permissions';
import { ViewMode } from '../../components/Common/ViewMode';
import { ParameterProvider } from '../../components/Parameter';

/**
 * switch for navigation of parameter pages 
 * @author Jungwirth
 */
export const ParameterMgmt: React.FC<{}> = (): JSX.Element => {
  return (
    <React.Fragment>
      <React.Suspense fallback={<SuspenseLoading />}>
        <ParameterProvider>
          <Switch>
            <PermissionRoute
              permission={[Permissions.ParameterCreate]}
              exact path={Routes.ParameterNew} render={(props) => <ParameterView {...props} viewMode={ViewMode.New} /> } />
            <Route exact path={Routes.ParameterRead} render={(props) => <ParameterView {...props} viewMode={ViewMode.Read} />} />
            <Route exact path={Routes.ParameterMgmt} component={Parameters} />
            <PermissionRoute 
              permission={[Permissions.ParameterUpdate]}
              exact path={Routes.ParameterEdit} render={(props) => <ParameterView {...props} viewMode={ViewMode.Edit} /> } />
            <PermissionRoute
              permission={[Permissions.ParameterDelete]}
              exact path={Routes.ParameterReject} render={(props) => <ParameterView {...props} viewMode={ViewMode.Delete} />} />
          </Switch>
        </ParameterProvider>
      </React.Suspense>
    </React.Fragment>
  );
};
